import React from 'react';
import { useLocalSessionId } from '@daily-co/daily-react';
import DailyMic from './DailyMic';

const LocalDailyMic: React.FC<{  }> = ({ }) => {
  const localUserId = useLocalSessionId();

  return (
    <DailyMic userId={localUserId} />
  );
};

export default LocalDailyMic;
